import React from "react";

const Notice = () => {
  return (
    <div className="card md:w-96 bg-[#e9c46a] text-black my-4">
      <div className="card-body">
        <h2 className="card-title">NOTICE!</h2>
        <p>
          If you provide any wrong information or fraud to any buyer/seller, we
          will band you forever.
        </p>
      </div>
    </div>
  );
};

export default Notice;
